import { render, staticRenderFns } from "./GatttableTr.vue?vue&type=template&id=35a3c0b9&"
import script from "./GatttableTr.vue?vue&type=script&lang=js&"
export * from "./GatttableTr.vue?vue&type=script&lang=js&"
import style0 from "./GatttableTr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports